import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  'Registrace nového účtu': "Registrieren Sie ein neues Konto",
  de: {
    translation: {
      snackbar: {
        dismiss: "verbergen"
      },
      form: {
        username: "Benutzername",
        password: "Passwort",
        email: "e-mail",
        fullName: "Vor- und Nachname",
        dataProcessingAgreement: "Zustimmung zur Verarbeitung personenbezogener Daten"
      },
      register: {
        validation: {
          dataProcessingAgreement: "Sie müssen der Verarbeitung personenbezogener Daten zustimmen, um fortfahren zu können",
        },
        form: {
          text: "Wenn Sie sich registrieren und Ihren Mitgliedsbeitrag an BMSJ zahlen, haben Sie Zugriff auf nicht öffentliche Dokumentabschnitte.\n\nGleichzeitig werden Sie unsere bisherige Arbeit zu schätzen wissen und die weitere Entwicklung und Forschung unterstützen.",
          title: "Registrieren Sie ein neues Konto",
          submit: "Registrieren",
          submiting: "Senden",
          successful: "Erfolgreiche Registrierung",
          error: {
            exists: "Ein Benutzer mit dieser E-Mail existiert bereits",
            default: "Problem mit der Registrierung auf unserer Seite, Administrator kontaktieren",
          }
        }
      },
      search: {
        form: {
          label: 'Suche',
          placeholder: 'Schreiben Sie hier',
          helperText: 'Wenn Sie nicht gefunden haben, wonach Sie gesucht haben, versuchen Sie, Ihre Suche zu verkürzen oder nach einem ähnlichen Text zu suchen',
          helperProperties: {
            help: "Suchhilfe",
            quotationMarks: "Anführungszeichen: Ein Ausdruck in dieser Form \"Ausdruck\" (in Anführungszeichen) findet eine genaue Übereinstimmung",
            asterisk: "Sterne: Markierter Ausdruck Len\* (Stern nach Ausdruck) sucht nach allen Übereinstimmungen, die mit Len beginnen, z. B. Lenka, Lenz usw. \n Ausdruck \*ka (Stern vor Ausdruck) sucht nach Lenka oder Karazka. \n Expression \*nk\* (mit einem Stern vor und nach dem Ausdruck) sucht nach: einkaufen, Pinkus etc.",
          },
          resultsTitle: 'Suchergebnisse'
        },
        columns: {
          introtext_snippet: "Spezifisches Clipping",
          title: "Name",
        }
      },
      login: {
        form: {
          title: "Einloggen",
          text: "",
          submit: "Anmelden",
          submiting: "Senden",
          successful: "Erfolgreiche Anmeldung",
          error: {
            exists: "Ein Benutzer mit dieser E-Mail existiert bereits",
            wrong: "Falsche E-Mail oder falsches Passwort",
          }
        }
      },
      //MUITable
      muitable: {
        body: {
          noMatch: 'Keine Übereinstimmungen gefunden'
        },
        footer: {
          next: 'Nächste Seite',
          previous: 'Vorherige Seite',
          rowsPerPage: 'Zeilen pro Seite',
          of: 'von',
        },
        tableHead: {
          sortBy: 'sortiere nach {{label}}',
        }
      },
      // YUP
      mixed: {
        required: '{{label}} ist ein Pflichtfeld'
      },
      number: {
        min: '{{path}} musí být větší nebo rovno {{min}}',
        max: '{{path}} musí být menší nebo rovno {{max}}',
        lessThan: '{{path}} musí být menší než {{less}}',
        moreThan: '{{path}} musí být větší než {{more}}',
        notEqual: '{{path}} se nesmí rovnat {{notEqual}}',
        positive: '{{path}} musí být kladné číslo',
        negative: '{{path}} musí být záporné číslo',
        integer: '{{path}} musí být celé číslo',
      },
      string: {
        length: '{{path}} musí být přesně {{length}} znaků',
        min: '{{path}} muss mindestens {{min}} Zeichen lang sein',
        max: '{{path}} darf nicht länger als {{max}} Zeichen sein',
        matches: '{{path}} musí odpovídat následujícímu: "{{regex}}"',
        email: '{{path}} muss in der richtigen Form sein',
        url: '{{path}} musí být platná URL',
        trim: '{{path}} musí být oříznutý řetězec',
        lowercase: '{{path}} musí být řetězec malých písmen',
        uppercase: '{{path}} musí být řetězec velkých písmen',
      },
      date: {
        min: '{{path}} pole musí být později než {{min}}',
        max: '{{path}} pole musí být dříve než {{max}}',
      },
      array: {
        min: 'pole {{path}} musí obsahovat alespoň {{min}} položek',
        max: '{{path}} pole musí mít méně nebo rovno {{max}} položek',
      },
      'Společnost pro dějiny židů v České Republice': "Gesellschaft für Geschichte der Juden in der Čechischen Republik",
      'Načítání': "Laden",
    }
  },
  cs: {
    translation: {
      snackbar: {
        dismiss: "skrýt"
      },
      form: {
        username: "uživatelské jméno",
        password: "heslo",
        email: "e-mail",
        fullName: "jméno a přijmení",
        dataProcessingAgreement: "souhlas se zpracováním osobních údajů"
      },
      register: {
        validation: {
          dataProcessingAgreement: "Pro pokračování musíte souhlasit se zpracováním osobních údajů.",
        },
        form: {
          text: "Registrací a zaplacením členského příspěvku organizaci BMSJ, získáte přístup k neveřejným sekcím dokumentů.\n\nZároveň tím oceníte naši dosavadní práci i podpoříte další vývoj a rešerše.",
          title: "Registrace nového účtu",
          submit: "zaregistrovat",
          submiting: "Odesílám",
          afterSuccessTitle: "Děkujeme za registraci.",
          afterSuccessMessage: "Validační email i s detaily o zaplacení členského poplatku byl odeslán na adresu {{email}}",
          successful: "Úspěšná registrace, validační email odeslán",
          error: {
            exists: "Uživatel s tímto emailem již existuje",
            default: "Problém s registrací na naší straně, kontaktujte správce",
          }
        }
      },
      login: {
        description: {
          mustLogin: "Pro zobrazení tohoto obsahu se musíte přihlásit",
        },
        form: {
          text: "",
          title: "Přihlášení",
          submit: "Přihlásit se",
          submiting: "Odesílám",
          successful: "Úspěšné přihlášení",
          logout: "Úspěšné odhlášení",
          error: {
            exists: "Uživatel s tímto emailem již existuje",
            wrong: "Nesprávný email nebo heslo",
          }
        }
      },
      search: {
        form: {
          label: 'Vyhledávání',
          placeholder: 'Zde pište',
          helperText: 'Pokud jste nenašli co jste hledali, zkuste váš výraz zkrátit, nebo vyhledat podobný text',
          helperProperties: {
            help: "Nápověda k vyhledávání",
            quotationMarks: "Uvozovky: Výraz v tomto tvaru \"výraz\" (v uvozovkách) vyhledá přesnou shodu",
            asterisk: "Hvězdičky: Výraz s hvězdičkou Len\* (s hvězdičkou za výrazem) vyhledá všechny shody které začínají na Len např. Lenka, Lenz atd.\nVýraz \*ka (s hvězdičkou před výrazem) vyhledá např.: Lenka nebo Karazká.\nVýraz \*nk\* (s hvězdičkou před i za výrazem) vyhledá např.: einkaufen, Pinkus atd.",
          },
          resultsTitle: 'Výsledky hledání',
          error: {
            '500': 'Problém na naší straně'
          }
        },
        columns: {
          introtext_snippet: "Konkrétní výstřižek",
          title: "Název",
        },
      },
      //MUITable
      muitable: {
        body: {
          noMatch: 'Nenašli jsme žádné záznamy odpovídající hledání'
        },
        footer: {
          next: 'Další stránka',
          previous: 'Předchozí stránka',
          rowsPerPage: 'Řádků na stránku',
          of: 'z',
        },
        tableHead: {
          sortBy: 'seřadit podle {{label}}',
        }
      },
      // YUP
      mixed: {
        required: '{{label}} je povinné pole'
      },
      number: {
        min: '{{path}} musí být větší nebo rovno {{min}}',
        max: '{{path}} musí být menší nebo rovno {{max}}',
        lessThan: '{{path}} musí být menší než {{less}}',
        moreThan: '{{path}} musí být větší než {{more}}',
        notEqual: '{{path}} se nesmí rovnat {{notEqual}}',
        positive: '{{path}} musí být kladné číslo',
        negative: '{{path}} musí být záporné číslo',
        integer: '{{path}} musí být celé číslo',
      },
      string: {
        length: '{{path}} musí být přesně {{length}} znaků',
        min: '{{path}} musí mít alespoň {{min}} znaků',
        max: '{{path}} musí mít maximálně {{max}} znaků',
        matches: '{{path}} musí odpovídat následujícímu: "{{regex}}"',
        email: '{{path}} musí být ve správném tvaru',
        url: '{{path}} musí být platná URL',
        trim: '{{path}} musí být oříznutý řetězec',
        lowercase: '{{path}} musí být řetězec malých písmen',
        uppercase: '{{path}} musí být řetězec velkých písmen',
      },
      date: {
        min: '{{path}} pole musí být později než {{min}}',
        max: '{{path}} pole musí být dříve než {{max}}',
      },
      array: {
        min: 'pole {{path}} musí obsahovat alespoň {{min}} položek',
        max: '{{path}} pole musí mít méně nebo rovno {{max}} položek',
      },
    }
  }
};

i18n
  .use(LanguageDetector) // passes i18n down to react-i18next
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "cs",
    detector: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
    },
    debug: true,
    //keySeparator: true, // we do not use keys in form messages.welcome
    //objectNotation: true,
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;
